import styled from "styled-components";
import {TextField} from "@mui/material";

export const Select = styled(TextField)``;

Select.defaultProps = {
	select: true,
};
